import { TextInput, Textarea, Text, Flex, Button, SimpleGrid, Box } from "@mantine/core";

interface ProductServiceItemFormProps {
  index: number;
  type: "product" | "service";
  data: any;
  onChange: (field: string, value: any) => void;
  onRemove: () => void;
  isViewMode?: boolean;
  errors?: { name?: string; description?: string };
}

const ProductServiceItemForm = ({
  index,
  type,
  data,
  onChange,
  onRemove,
  isViewMode = false,
  errors,
}: ProductServiceItemFormProps) => {
  const itemLabel = `${type === "product" ? "Product" : "Service"} ${index + 1}`;
  const fieldPrefix = type === "product" ? "product" : "service";

  return (
    <Flex direction="column" p="lg">
      <Flex justify="space-between" align="center" mb="md">
        <Text fw={500}>{itemLabel}</Text>
        {!isViewMode && (
          <Flex gap="sm" align="center">
            <Button variant="subtle" color="red" size="sm" onClick={onRemove}>
              Remove
            </Button>
          </Flex>
        )}
      </Flex>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        <Box id={`gt-field-${fieldPrefix}-${index}-name`}>
          <TextInput
            label={`${type === "product" ? "Product" : "Service"} Name`}
            placeholder={type === "product" ? "e.g., M8 Hex Bolts" : "e.g., CNC Machining Service"}
            required
            value={data.name || ""}
            onChange={(e) => onChange("name", e.target.value)}
            readOnly={isViewMode}
            error={errors?.name}
          />
        </Box>

        <Box id={`gt-field-${fieldPrefix}-${index}-description`}>
          <Textarea
            label="Description"
            placeholder={
              type === "product"
                ? "Describe the product specifications, materials, standards..."
                : "Describe the service, capabilities, turnaround time..."
            }
            required
            autosize
            minRows={1}
            value={data.description || ""}
            onChange={(e) => onChange("description", e.target.value)}
            readOnly={isViewMode}
            error={errors?.description}
          />
        </Box>
      </SimpleGrid>
    </Flex>
  );
};

export default ProductServiceItemForm;
